import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

import { ScreenWidth } from '@joinforma/ui/constants/breakpoints';

import { ReactComponent as FormaLogo } from 'assets/images/forma-logo-dark.svg';

import Head from '@joinforma/ui/components/Head';

import { WelcomeLayoutPageProps } from './types';

interface ContainerProps {
  padding?: boolean;
}

const Container = styled.div<ContainerProps>`
  position: absolute;
  background-color: ${({ theme }) => theme.colors.brand.primary};
  padding: 16px;
  width: 100%;
  overflow: auto;
  height: ${({ padding }) => (padding ? '100vh' : '')};

  @media (min-width: ${ScreenWidth.TABLET_PORTRAIT}) {
    padding: 69px 0px 0px 60px;
  }

  @media (min-width: ${ScreenWidth.LAPTOP}) {
    padding: ${({ padding }) =>
      padding ? '69px 0px 0px 80px' : '69px 80px 0px 80px'};
  }

  @media (min-width: ${ScreenWidth.DESKTOP}) {
    padding: ${({ padding }) =>
      padding ? '69px 0px 0px 80px' : '69px 80px 0px 80px'};
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  @media (min-width: ${ScreenWidth.TABLET_PORTRAIT}) {
    padding-right: 80px;
  }

  @media (min-width: ${ScreenWidth.LAPTOP}) {
    padding: 0px;
  }
`;

const StyledLogo = styled(FormaLogo)`
  width: 160px;
  margin-left: -20px;
`;

const CompanyLogo = styled.img`
  width: 100px;

  @media (min-width: ${ScreenWidth.LAPTOP}) {
    width: 160px;
    margin-right: 80px;
  }

  @media (min-width: ${ScreenWidth.DESKTOP}) {
    width: 160px;
    margin-right: 40px;
  }
`;

const WelcomePageLayoutV2 = ({
  companyLogo,
  memberLandingPage,
}: WelcomeLayoutPageProps) => (
  <Container padding={memberLandingPage}>
    <Head title="Onboarding" />
    <HeaderContainer>
      <StyledLogo />
      <CompanyLogo src={companyLogo} />
    </HeaderContainer>
    <Outlet />
  </Container>
);

export default WelcomePageLayoutV2;
